export const INITIALIZE_VALUES = 'valueSet/INITIALIZE_VALUES';
export const INCREMENT_VALUE_LAYER = 'valueSet/INCREMENT_VALUE_LAYER';
export const DECREMENT_VALUE_LAYER = 'valueSet/DECREMENT_VALUE_LAYER';
export const INCREMENT_DISPLAY_LAYER = 'valueSet/INCREMENT_DISPLAY_LAYER';
export const DECREMENT_DISPLAY_LAYER = 'valueSet/DECREMENT_DISPLAY_LAYER';

export const initializeValues = (valueArray) => {
  console.log('Initializing Values');
  return {
    type: INITIALIZE_VALUES,
    valueArray,
  };
};

export const incrementValueLayer = valueId => ({
  type: INCREMENT_VALUE_LAYER,
  valueId,
});

export const decrementValueLayer = valueId => ({
  type: DECREMENT_VALUE_LAYER,
  valueId,
});

export const incrementDisplayLayer = () => ({
  type: INCREMENT_DISPLAY_LAYER,
});

export const decrementDisplayLayer = () => ({
  type: DECREMENT_DISPLAY_LAYER,
});



// WEBPACK FOOTER //
// ./src/actions/valueSet.js